import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { apiGetNotification, apiUpdateNotification } from "../../../api/ApiNotification";
import { useSelector } from "react-redux";

const ModalUpdate = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const initialState = {
    title: "",
    datePeremption: "",
    importance: "normal",
    body: "",
  };

  const [state, setState] = useState(initialState);

  const datePlus = (nbJours = 1) => {
    var futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + nbJours);
    var finalDate =
      futureDate.getFullYear() +
      "-" +
      (futureDate.getMonth() + 1 < 10 ? "0" : "") +
      (futureDate.getMonth() + 1) +
      "-" +
      (futureDate.getDate() < 10 ? "0" : "") +
      futureDate.getDate();

    return finalDate;
  };

  const recupData = async () => {
    const res = await apiGetNotification(ReduxInstance._id, id);
    // au cas ou on ait pas de date de peremption, on en propose une dans -1 jours (utile pour les anciennes notifs sans date de peremption)
    if (!res.data.datePeremption) res.data.datePeremption = datePlus(-1);

    let date = new Date(res.data.datePeremption);
    res.data.datePeremption =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());

    setState(res.data);
  };

  const submitData = async () => {
    await apiUpdateNotification(id, state);
    handleRecupDatas();
    handleClose();
  };

  useEffect(() => {
    if (id) {
      recupData();
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminNotifications.modalUpdateTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.titreNotif")} *</label>
          <Form.Control
            type="text"
            name="title"
            value={state.title}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.dateNotif")} *</label>
          <Form.Control
            type="date"
            min={datePlus(0)}
            name="datePeremption"
            value={state.datePeremption}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.importanceNotif")} *</label>
          <Form.Select
            name="importance"
            value={state.importance}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          >
            {/* <option value="verylow">{t("commun.form.label.importanceNotifTresBasse")}</option> */}
            {/* <option value="low">{t("commun.form.label.importanceNotifBasse")}</option> */}
            <option value="normal">{t("commun.form.label.importanceNotifNormale")}</option>
            <option value="high">{t("commun.form.label.importanceNotifHaute")}</option>
            {/* <option value="veryhigh">{t("commun.form.label.importanceNotifTresHaute")}</option> */}
          </Form.Select>
          <label className="mt-2">{t("commun.form.label.contenuNotif")} *</label>
          <Form.Control
            as="textarea"
            type="text"
            name="body"
            style={{ height: "200px" }}
            value={state.body}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUpdate;
